module.exports = __webpack_public_path__ + "img/t1_rnd_pt_wing_bolt.prt.69c4f59d.jpg";